function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 10,
  fill: "#1976D2",
  width: 42,
  height: 29
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#1976D2",
  cx: 24,
  cy: 36,
  r: 5
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  fill: "#263238",
  cx: 24,
  cy: 36,
  r: 3
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#CFD8DC",
  points: "40,7 25,10 23,10 8,7 6,12 6,36 42,36 42,12 "
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0BEC5",
  d: "M8,33h15v3h2v-3h15l2,3H6L8,33z M25,10h-2v26h2V10z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ECEFF1",
  d: "M40,33c0,0-15,0-15,3c0,0,0-23,0-26s15-3,15-3V33z M8,33c0,0,15,0,15,3c0,0,0-23,0-26S8,7,8,7V33z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#2196F3",
  d: "M33.9,28h-2.8V17h2.8V28z M34,13.5c0-0.8-0.7-1.5-1.5-1.5S31,12.7,31,13.5s0.7,1.5,1.5,1.5S34,14.3,34,13.5"
});

var SvgManual = function SvgManual(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManual, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/manual.f4c87839.svg";
export { ForwardRef as ReactComponent };